/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import auth from "src/auth/authService";


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const userDefaults = {
  // uid         : 0,          // From Auth
  // displayName : "نیلوفر هدهدی نژاد", // From Auth
  // about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  // photoURL    : require("@/assets/images/pages/dashboard/user2.svg"), // From Auth
  // status      : "online",
  // userRole    : "admin"
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    // AppActiveUser           : userDefaults,
    ref                     : "",
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    userInfo: {name: '', family: ''},
    userinformation: '',
    userId: '',
    UserExistError: false,
    accountInfo:{},
    refreshToken: '',
    authToken: '',
    userStep: '',
    tokenExpired: false,
    currentTicket: {},
    categories: [],
    priorityList : [
      { text: "بحرانی", value: "Critical" },
      { text: "زیاد", value: "High" },
      { text: "متوسط", value: "Medium" },
      { text: "کم", value: "Low" },
      { text: "خیلی کم", value: "VeryLow" },
    ],
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    isUserLoggedIn: () => {
      return auth.isAuthenticated()
  },
}

export default state
